import { CheckCircleOutlined, CloseCircleOutlined, LoadingOutlined } from '@ant-design/icons'
import { useUnmountedRef } from 'ahooks'
import { Input, InputNumber } from 'antd'
import { useRef, useState } from 'react'
import styled from 'styled-components'

interface ConfirmInputProps extends React.ComponentProps<typeof Input> {
  name: string
  id: any
  onCancel?: (newName?: string, id?: number) => void | Promise<any>
  onOk?: (newName: string, id: string) => void | Promise<any>
  verification?: (newName: string, id: string) => void | Promise<any>
  unit?: string
}

type ValueType = number | null

export const ConfirmInput = (props: ConfirmInputProps) => {
  const {
    onCancel = () => {},
    onOk = () => {},
    name,
    id,
    type = 'input', // 'input' | 'inputNumber'
    min,
    max,
    unit = '',
    verification = () => {},
    ...other
  } = props
  const inputContentRef = useRef(name)
  const isUnMount = useUnmountedRef()
  const [loading, setLoding] = useState<'cancel' | 'ok' | ''>('')

  const cancelHandler = async () => {
    if (loading) return
    try {
      setLoding('cancel')
      await onCancel(inputContentRef.current, id)
    } catch (e) {
    } finally {
      if (!isUnMount.current) {
        setLoding('')
      }
    }
  }
  const okHandler = async () => {
    if (loading) return
    try {
      setLoding('ok')
      await verification(inputContentRef.current, id)
      await onOk(inputContentRef.current, id)
    } catch (e) {
    } finally {
      if (!isUnMount.current) {
        setLoding('')
      }
    }
  }

  return type === 'input' ? (
    <Input
      onChange={e => {
        inputContentRef.current = e.target.value
      }}
      defaultValue={name}
      {...other}
      suffix={
        <IconContaienr>
          {loading === 'cancel' ? (
            <LoadingOutlined />
          ) : (
            <CloseCircleOutlined className="icon" onClick={cancelHandler} />
          )}
          {loading === 'ok' ? (
            <LoadingOutlined />
          ) : (
            <CheckCircleOutlined className="icon" onClick={okHandler} />
          )}
        </IconContaienr>
      }
    />
  ) : (
    <InputNumberContainer>
      <InputNumber
        onChange={(value: ValueType | null) => {
          inputContentRef.current = value
        }}
        defaultValue={name}
        min={min}
        max={max}
        {...other}
      />
      <span>{unit}</span>
      <IconContaienr style={{ marginLeft: 5, marginRight: 5 }}>
        {loading === 'cancel' ? (
          <LoadingOutlined />
        ) : (
          <CloseCircleOutlined className="icon" onClick={cancelHandler} />
        )}
        {loading === 'ok' ? (
          <LoadingOutlined />
        ) : (
          <CheckCircleOutlined className="icon" onClick={okHandler} />
        )}
      </IconContaienr>
    </InputNumberContainer>
  )
}

const IconContaienr = styled.div`
  display: flex;
  width: 36px;
  justify-content: space-between;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  .icon {
    color: #999;
    &:hover {
      color: #4238c9;
    }
  }
`

const InputNumberContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
